"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import MilesFoundationForm from "../forms/MilesFoundationForm";

const FoundationWebinar: React.FC = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  // Check if form was previously submitted on component mount
  useEffect(() => {
    const formSubmitted = localStorage.getItem("gccMpactFormSubmitted");
    if (formSubmitted === "true") {
      setIsFormSubmitted(true);
    }
  }, []);

  const handleFormSubmit = () => {
    setIsFormSubmitted(true);
  };

  return (
    <div className="w-full bg-[#061A2F]">
      <div className="main_container mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-10 relative">
          {/* Left Content */}
          <div className="flex flex-col justify-center gap-3 lg:gap-6 py-8 lg:py-14">
            <h2 className="text-2xl md:text-[60px] font-bold text-left text-[#FFBA08] leading-[1.16]">
              Why it
              <br className="hidden md:block" /> Matters?
            </h2>

            <p
              className="font-medium text-sm md:text-xl text-left max-w-[560px]
              bg-[linear-gradient(90deg,#39F_0.07%,#FFF_62.39%)]
              bg-clip-text text-transparent leading-normal"
            >
              Social outreach is no longer an elective; it is an essential.
              Through Miles-validated certification, we ensure that every hour a
              student spends in a village translates into measurable credit for
              their degree and a tangible asset for the country.
            </p>
          </div>

          {/* Center Image */}
          <div className="flex justify-center md:relative md:left-[-40px] right-3 md:bottom-0 bottom-[-55px] md:h-auto h-[240px] relative">
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/home_new/girl_at_right_point.webp"
              alt="Join Us"
              width={317}
              height={420}
              className="w-[198px] md:w-[306px] h-auto object-contain"
            />
          </div>

          {/* Form */}
          <div className="col-span-2 lg:col-span-1 flex flex-col items-center justify-center gap-6 lg:py-16 pb-8">
            <div className="flex lg:justify-end w-full">
              <div className="relative w-full lg:max-w-[400px] p-4 rounded-2xl border border-white bg-white/10 shadow-[0_0_14px_rgba(4,84,175,0.29)] backdrop-blur-[28px]">
                {!isFormSubmitted && (
                  <h2 className="text-white md:text-2xl text-center font-semibold pb-4">
                    Join the National Conclave on
                    <br /> Youth for Nation-Building
                  </h2>
                )}
                <MilesFoundationForm
                  submitButtonName="Register for the Conclave"
                  darkBackground
                  onFormSubmit={handleFormSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoundationWebinar;
